import { TabsWrapper } from '@components/Steps/Steps.styles';
import { LuxTabsGroup } from '@gemini/fe-ds-core';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { usePatientStore } from '@store/patientStore';
import { StepsStep } from '@utils/enums/StepsStep.enum';
import { generateSortedPatientsList } from '@utils/functions';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface MultiplePatientsTabsProps {
  isNotVisibleStep?: StepsStep;
  onSelect?: () => void;
}

const MultiplePatientsTabs = ({
  isNotVisibleStep,
  onSelect,
}: MultiplePatientsTabsProps) => {
  // step 0 utente non creato... => situazione attuale [u,u,u]
  // step 1 utente aggiunto (seleziono appt) => situazione attuale [u,u,u] situazione post [0,u,u]
  // order = 0 -> posizione [0]
  // step 2 utente aggiunto (seleziono appt) => situazione attuale [0,u,u] situazione post [0,1,u]
  // order = 0 -> posizione [0]
  // order = 1 -> posizione [1]
  // step 3 utente cancellato posizione 0 => situazione attuale [0,1,u] situazione post [u,1,u]
  // order = 1 -> posizione [1]
  // step 4 utente aggiunto => situazione attuale [u,1,u] situazione post [0,1,u]
  // mi prendo l'order più grande (della situazione attuale) ... 1, al nuovo utente l'order è ((più grnade) + 1)
  // logica di "spazio libero" più a sinistra => situazione attuale [u,1,u] allora lo "spazio" libero è 0
  // order = 2 -> posizione [0]
  // order = 1 -> posizione [1]
  const { t } = useTranslation();
  const patients = usePatientStore(state => state.patients);
  const currentPatientIndex = useOnlineBookingStore(
    state => state.currentPatient,
  );
  const showAddPatientFrame = useOnlineBookingStore(
    state => state.showAddPatientFrame,
  );
  const currentFormStep = useOnlineBookingStore(state => state.currentFormStep);
  const isStartedNewPatient = useOnlineBookingStore(
    state => state.isStartedNewPatient,
  );

  const setCurrentPatient = useOnlineBookingStore(
    state => state.setCurrentPatient,
  );
  const setShowDeletePatientModal = usePatientStore(
    state => state.setShowDeletePatientModal,
  );

  const showTabs = useMemo(() => {
    const onlyTruePatient = patients.filter(p => p);
    return (
      (onlyTruePatient.length > 1 || isStartedNewPatient) &&
      (!isNotVisibleStep || currentFormStep !== isNotVisibleStep) &&
      currentFormStep !== StepsStep.CONTACT_DETAILS &&
      !showAddPatientFrame
    );
  }, [
    isStartedNewPatient,
    patients,
    currentFormStep,
    isNotVisibleStep,
    showAddPatientFrame,
  ]);

  const patientsTabs = useMemo(
    () => generateSortedPatientsList(patients, t),
    [patients],
  );

  const handleDelete = () => {
    setShowDeletePatientModal(true);
  };

  return (
    <>
      {showTabs && (
        <TabsWrapper>
          <LuxTabsGroup
            tabs={patientsTabs}
            noLabel
            onSelect={i => {
              setCurrentPatient(i as number);
              if (typeof onSelect === 'function') {
                onSelect();
              }
            }}
            selected={currentPatientIndex}
            showIcon={false}
            onDelete={_ => handleDelete()}
            customDeleteIcon={'CloseIcon'}
            deleteIconOnlyOnSelected
            selectedTabBlack
            customDeleteIconBackground="white"
          />
        </TabsWrapper>
      )}
    </>
  );
};

export default MultiplePatientsTabs;
